import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOSchema from '@/components/feature/SEOSchema';
import useScrollToTop from '@/hooks/useScrollToTop';
import { allComics } from '@/mocks/comics';
import { HeroSection, StatsBanner, CategoryNav, FeaturedComics, LatestUpdates, SearchSection, HomeFAQ } from './components/HomeSections';
import { useEffect } from 'react';

export default function Home() {
  useScrollToTop();

  useEffect(() => {
    document.title = '虚空韩漫网-韩漫在线阅读_免费的韩国漫画大全_无删减下拉式韩漫';
  }, []);

  const topRated = [...allComics].sort((a, b) => b.rating - a.rating).slice(0, 6);
  const mostViewed = [...allComics].sort((a, b) => b.views - a.views).slice(0, 6);
  const ongoing = allComics.filter((c) => c.status === '连载中').slice(0, 6);

  return (
    <>
      <SEOSchema type="Organization" />
      <SEOSchema type="WebSite" />
      <SEOSchema type="WebPage" data={{ name: '虚空韩漫网 - 首页', url: 'http://0661yes.cn/' }} />
      <SEOSchema type="FAQPage" data={{
        questions: [
          { question: '虚空韩漫网的漫画都是免费的吗？', answer: '是的！虚空韩漫网上的所有韩国漫画都完全免费，无需付费即可畅享海量韩漫资源。' },
          { question: '什么是下拉式韩漫？如何阅读？', answer: '下拉式韩漫是韩国漫画的特色阅读方式，您只需向下滑动页面即可连续阅读，无需翻页。' },
          { question: '网站上的漫画多久更新一次？', answer: '虚空韩漫网每天都会更新大量最新漫画章节，热门连载作品通常每周更新1-2话。' },
        ],
      }} />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <HeroSection />
          <StatsBanner />
          <CategoryNav />
          <FeaturedComics
            title="热门推荐"
            subtitle="读者评分最高的韩漫作品"
            comics={topRated}
            showViewAll
            viewAllLink="/category/all"
          />
          <LatestUpdates />
          <FeaturedComics
            title="连载热追"
            subtitle="正在连载中的热门韩漫"
            comics={ongoing}
            showViewAll
            viewAllLink="/category/all"
          />
          <FeaturedComics
            title="人气爆棚"
            subtitle="阅读量最高的韩漫作品"
            comics={mostViewed}
            showViewAll
            viewAllLink="/category/all"
          />
          <SearchSection />
          <HomeFAQ />
        </main>

        <Footer />
      </div>
    </>
  );
}